import  { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import ExperimentReportMobile from "./ExperimentReportMobile";
import {
  FormControl,
  TextField,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import Report from "./Report";
import { useLocalStorage } from "@uidotdev/usehooks";
import isDesktop from "../isDesktop";
import { ToastContainer, toast } from "react-toastify";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { hasStoredTabAccess } from '../utils/access';

const ExperimentReport = ({users}) => {
  const isDesktopDevice = isDesktop();
  // eslint-disable-next-line no-unused-vars
  const [token,setToken] = useLocalStorage('token',null);
  const [experiment, setExperiment] = useState([]);
  const [filter, setFilter] = useState(null);
  const [labs, setLabs] = useState([]);
  const [selectedLab, setSelectedLab] = useState([]);
  const [currentExperiments, setCurrentExperiments] = useState([]);
  const [fromDate, setFromDate] = useState(dayjs("01/01/2024"));
  const [toDate, setToDate] = useState(dayjs());
  const [selectedExperiment, setSelectedExperiment] = useState("");
  const [showReport, setShowReport] = useState(false);
  const isAuthorized = hasStoredTabAccess('Report');

  const fetchLabs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/labs/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status == 200) {
        const temp = response?.data?.data?.map((val) => {
          return {
            label: val?.lab_name,
            id: val?.lab_id,
          };
        });
        // console.log(typeof temp);

        setLabs(temp);
      }
    } catch (error) {
      toast.error("Error Fetching Labs");
      console.error(error);
    }
  };
console.log(labs);

  const fetchExperiments = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/experiment/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setExperiment(response.data.data);
      } else {
        console.error("Error fetching experiments:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching experiments:", error);
    }
  };



  const handleInputChange = (e, value) => {
    setFilter(value?.username);
  };

  const handleReset = () => {
    setSelectedLab("");
    setFilter("");
    setSelectedExperiment("");
  };

  useEffect(()=>{
    if (!isAuthorized) return;
    fetchLabs();
  },[isAuthorized])
// console.log(selectedLab);

  useEffect(() => {
    if(isDesktopDevice && isAuthorized){
      // fetchReports();
  
    fetchExperiments();
    }
  }, [selectedExperiment, isAuthorized, isDesktopDevice]);
  console.log(fromDate.toDate());
  
  const handleExportClick = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/report/export-experiment`,
        {
          name: filter,
          lab_id:selectedLab.id,
          experiment_id: selectedExperiment.id,
          from:fromDate.toDate()||null,
          to:toDate||null
        },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "experimentAttempts.xlsx");
      document.body.appendChild(link);
      link.click();

      console.log("File exported successfully");
    } catch (error) {
      console.error("Error exporting file:", error);
    }
  };


  const labChangeHandler = (e, value) => {
    console.log(value);

    setExperiment(value);
    const temp = experiment
      ?.filter((val) => (val.lab_id === value?.id))
      ?.map((val) => {
        return {
          label: val?.experiment_name,
          id: val?.experiment_id,
        };
      });
    setSelectedLab(value)
    setSelectedExperiment([]);
    setCurrentExperiments(temp);
  };

  const experimentChangeHandler = (e, value) => {
    setSelectedExperiment(value);
  };

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2>You are unauthorized to access this page</h2>
      </div>
    );
  }


  return (
    <>
    {
      isDesktopDevice ? (
        <>
        {showReport &&
          <Report
            setShowReport={setShowReport}
          />
        }
          <div className="container-fluid mt-3 p-0">
            <ToastContainer />
            <div className="align-center-all full-height">
                <CardContent>
                  <div className="filters">
                  <div className="sub-title">Experiment Report</div>
                    <div
                      style=
                      {{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                      }}
                    >
                      <div className="fieldContainer">
                      <div className="leftFields">
                      {/* <FormControl
                      fullWidth
                      className="mb-3 customTextfield"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'transparent',
                          },
                          '&:hover fieldset': {
                            borderColor: 'transparent',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'transparent',
                            boxShadow: 'none',
                          },
                        },
                        width: '32.051vw'
                      }}
                      >
                        <InputLabel id="experiment-label">
                          Labs
                        </InputLabel>
                        <Select
                          labelId="experiment-label"
                          id="experiment-select"
                          label="Experiment"
                        >
                          <MenuItem
                          >
                          </MenuItem>
                        </Select>
                      </FormControl> */}
                      <Autocomplete
                        className="mb-3"
                        // style={{ marginTop: '0.313rem' }}
                        value={selectedLab}
                        fullWidth
                        options={labs}
                        // getOptionLabel={option=>option.label}
                        // getOptionLabel={(option)=>option.label}  
                        onChange={(e, value) => {
                          labChangeHandler(e, value);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id || value === null
                        }
                        renderInput={(params) => (
                          <TextField fullWidth {...params} label="Labs" sx={{
                             '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: 'transparent',
                              },
                              '&:hover fieldset': {
                                borderColor: 'transparent',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'transparent',
                                width: '100%',
                                boxShadow: 'none',
                              },
                            },
                            width: '32.051vw'
                          }}
                          InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                          }}
                          style={{
                            boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                          }} />
                        )}
                    />
                        {/* <FormControl
                        fullWidth
                        className="mb-3 customTextfield"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: 'transparent',
                            },
                            '&:hover fieldset': {
                              borderColor: 'transparent',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: 'transparent',
                              boxShadow: 'none',
                            },
                          },
                          width: '32.051vw'
                        }}
                        >
                          <InputLabel id="experiment-label">
                            Experiment
                          </InputLabel>
                          <Select
                            labelId="experiment-label"
                            id="experiment-select"
                            value={selectedExperiment}
                            onChange={handleExperimentChange}
                            label="Experiment"
                          >
                            {experiment?.map((experimentItem) => (
                              <MenuItem
                                key={experimentItem.experiment_id}
                                value={experimentItem.experiment_id}
                              >
                                {experimentItem.experiment_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        */}
                      <Autocomplete
                        className="mb-3"
                        value={selectedExperiment}
                        fullWidth
                        options={currentExperiments}
                        onChange={(e, value) => {
                          experimentChangeHandler(e, value);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id || value === null
                        }
                        renderInput={(params) => (
                          <TextField fullWidth {...params} label="Experiments" sx={{
                            width: '100%', '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: 'transparent',
                              },
                              '&:hover fieldset': {
                                borderColor: 'transparent',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'transparent',
                                width: '100%',
                                boxShadow: 'none',
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                          }}
                          style={{
                            boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                          }} />
                        )}
                      />
                      </div>
                      <div className="rightFields">
                        <FormControl
                          className="mb-3 dateField"
                          sx={{
                            width: '100%', '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: 'transparent',
                              },
                              '&:hover fieldset': {
                                borderColor: 'transparent',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'transparent',
                                width: '100%',
                                boxShadow: 'none',
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                          }}
                          style={{
                            boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="From"
                              value={fromDate}
                              onChange={(value) => {
                                setFromDate(dayjs(value).endOf("day"));
                              }}
                            />
                          </LocalizationProvider>
                        </FormControl>
                        <FormControl
                          fullWidth
                          className="mb-3 dateField"
                          sx={{
                            width: '100%', '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: 'transparent',
                              },
                              '&:hover fieldset': {
                                borderColor: 'transparent',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'transparent',
                                width: '100%',
                                boxShadow: 'none',
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                            required: false
                          }}
                          style={{
                            boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="To"
                              value={toDate}
                              onChange={(value) => {
                                setToDate(dayjs(value).endOf("day"));
                              }}
                            />
                          </LocalizationProvider>
                        </FormControl>
                        <Autocomplete
                          id="userId"
                          options={users}
                          value={filter ? users.find((user) => user.username === filter) : null}
                          onChange={handleInputChange}
                          getOptionLabel={(option) => option.username}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              // label="Name"
                              variant="outlined"
                              fullWidth
                              placeholder="Username"
                              className="mb-3 customTextfield"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: 'transparent',
                                  },
                                  '&:hover fieldset': {
                                    borderColor: 'transparent',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: 'transparent',
                                    boxShadow: 'none',
                                  },
                                },
                                width: '32.051vw'
                              }}
                              InputLabelProps={{
                                sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                                required: false
                              }}
                            />
                          )}
                        />
                      </div>
                      </div>
                        <div style={{display: 'flex', gap: '1.3vw', alignItems: 'center', justifyContent: 'center' }}>
                          <Button
                            variant="outlined"
                            className="outlined-button"
                            onClick={handleReset}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="contained"
                            onClick={handleExportClick}
                            className="filled-button"
                          >
                            Export
                          </Button>
                        </div>
                    </div>
                  </div>
                </CardContent>
            </div>
          </div>
        </>
      ) : (
        <ExperimentReportMobile />
      )
    }
    </>
  );
};

export default ExperimentReport;
